export default "/images/62e76f86802d077df645920d7f1e89f8.avif";